export enum PlatformEnum {
    web = 'web',
    android = 'android',
    and = 'and',
    ios = 'ios'
}
